<template>
  <div id="splStandDetail" class="details-content splStand-detail">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toBiddingActivities">展位竞价/</span
        >查看详情
      </template>
      <template v-slot:content>
        <div class="add-promotion">
          <el-button
          :class="standDetailsList.length>0?'btn-black':'btn-blue'"
          :disabled="standDetailsList.length>0"
          @click="addGoods">新增商品</el-button>
        </div>
        <section class="content base-info" ref="baseInfo">
          <div class="content-title">基础信息</div>
          <ul class="content-info">
            <li class="item">
              <span class="desc">竞价序号：</span
              >{{ standDetail.serial }}
            </li>
            <li class="item">
              <span class="desc">起拍价格：</span
              >￥{{ standDetail.basePrice }}
            </li>
            <li class="item">
              <span class="desc">到期时间：</span
              >{{ standDetail.expireTime }}
            </li>
          </ul>
        </section>
        <section class="content customer-info">
          <div class="content-title">竞价商品</div>
          <div class="out-container" v-if="standDetailsList.length > 0">
            <div class="table">
              <el-table class="table-container" :data="standDetailsList">
                <el-table-column
                  label="创建时间"
                  prop="boothGoodsCreatedAt"
                ></el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="goodsName"
                ></el-table-column>
                <el-table-column
                  label="当前出价"
                  prop="currentPrice"
                ></el-table-column>
                <el-table-column label="状态"
                                 prop="isSelectedValue"></el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button
                      v-if="standDetail.biddingStatus == 2"
                      class="btn-text"
                      type="text"
                      @click="modifyBidding(scope.row)"
                      >修改竞价</el-button
                    >
                    <el-button
                      v-if="standDetail.biddingStatus == 2"
                      class="btn-text"
                      type="text"
                      @click="revoke(scope.row.boothGoodsId)"
                      >撤销</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="nothing" v-else>
            <div class="img">
              <img src="../../../../assets/bidding/nothing.png" />
            </div>
          </div>
        </section>
        <div class="operations" ref="operations">
          <el-button class="btn-white" @click="toBiddingActivities"
            >返回</el-button
          >
        </div>
      </template>
    </second-menu-link-content>
    <el-dialog class="modify-bidding" title="修改竞价" :visible.sync="dialogVisible" width="30%">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="当前金额：" prop="biddingPrice">
          {{ ruleForm.biddingPrice }}
        </el-form-item>
        <el-form-item label="修改金额：" prop="price">
          <el-input
            v-model="ruleForm.price"
            placeholder="请输入金额"
            @input="onInputModifyPrice(ruleForm.price)"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加商品--弹框 -->
    <el-dialog
      title="添加商品"
      :visible.sync="dialogTableVisible"
      width="1200px"
      top="20vh"
    >
      <!-- 黑色的线条 -->
      <div class="border"></div>
      <!-- 表格部分 -->
      <div class="flex">
        <div class="flex-left">
          <div class="dialog-search">
            <el-cascader
              ref="cascader"
              clearable
              class="gray w160"
              v-model="dialogForm.classify"
              :options="classify"
              :props="defaultParams"
              placeholder="请选择分类"
              filterable
              :show-all-levels="false"
            ></el-cascader>
            <el-input
              class="gray"
              placeholder="请输入商品名称"
              clearable
              @keyup.enter.native="searchGoods"
              v-model="dialogForm.goodsName"
            ></el-input>
            <el-button type="text" class="btn-blue" @click="searchGoods"
              >搜索</el-button
            >
          </div>
          <div class="table-img">
            <el-table height="260" :data="dialogTableList" style="width: 100%">
              <el-table-column label="商品名称" width="250">
                <template slot-scope="scope">
                  <img :src="scope.row.img" class="img" />
                  <p class="name">{{ scope.row.goodsName }}</p>
                </template>
              </el-table-column>
              <el-table-column
                label="商品分类"
                prop="classify"
              ></el-table-column>
              <el-table-column width="80">
                <template slot-scope="scope">
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="choiceGoods(scope.row)"
                    >选择</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="table_pagination">
              <pagination-tpl
                :total="total"
                :pageCount="pageCount"
                :currentPage="page"
                @queryChange="updatePage"
              ></pagination-tpl>
            </div>
          </div>
        </div>
        <div class="flex-right">
          <div class="table-img">
            <el-table
              :data="selectDialogTableData"
              style="width: 100%"
            >
              <el-table-column label="商品名称">
                <template slot-scope="scope">
                  <img :src="scope.row.img" class="img" />
                  <p class="name">{{ scope.row.goodsName }}</p>
                </template>
              </el-table-column>
              <el-table-column label="竞价金额">
                <template slot-scope="scope">
                  <el-input
                  class="gray"
                  clearable
                  v-model="selectDialogGoods.biddingPrice" 
                  @input="onInputBiddingPrice(selectDialogGoods.biddingPrice)"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="80">
                <template slot-scope="scope">
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="deleteGoodsItems(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveGoodsSku">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formaTimeToSecond } from "common/js/util.js";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
export default {
  data() {
    return {
      boothId: '',
      // 基础信息
      standDetail: {},
      // 竞价商品列表
      standDetailsList: [],
      goodsName: "",
      dialogVisible: false,
      ruleForm: {
        biddingPrice: "",
        price: "",
      },
      itemId: '', //修改竞价id
      // 选择商品--弹框
      dialogTableVisible: false,
      // 弹窗表单
      dialogForm: {
        classify: [],
        goodsName: "",
      },
      // 弹窗搜索值
      dialogFormSearch: {
        classify: [],
        goodsName: "",
      },
      // 分类数据
      classify: [],
      defaultParams: {
        label: "cateName",
        value: "id",
        children: "children"
      },
      // 弹窗商品列表
      dialogTableList: [],
      total: 0,
      page: 1,
      pageCount: 5,
      // 选中的商品的详细数据
      selectDialogGoods: {
        id: "",
        biddingPrice: ''
      },
      isSelectedValue: {
        0: '未选中',
        1: '已选中',
        2: '未选择',
      },
      // 选择选中的商品的sku的数据
      selectDialogTableData: [],
    };
  },
  methods: {
    // 限制竞价金额的输入
    onInputBiddingPrice(price) {
      let biddingPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.$set(this.selectDialogGoods, "biddingPrice", biddingPrice);
    },
    // 限制修改金额的输入
    onInputModifyPrice(price) {
      let modifyPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.$set(this.ruleForm, "price", modifyPrice);
    },
    // 商品列表搜索
    searchGoods() {
      this.dialogFormSearch = this.dialogForm;
      this.getGoodsListData();
    },
    // 获取商品列表数据
    getGoodsListData() {
      let length = this.dialogFormSearch.classify.length;
      let category1Id;
      if (length > 0) {
        category1Id = this.dialogFormSearch.classify[length - 1];
      } else {
        category1Id = Number(this.$route.query.categoryId);
      }
      let goodsName = this.dialogFormSearch.goodsName;
      let currentPage = this.page;
      let options = {
        currentPage,
        category1Id,
        goodsName
      };
      supplier.getSupplierBiddingGoodsDetail(options).then(res => {
        if (res.success) {
          this.total = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.img = value.itemImages[0]
              ? value.itemImages[0]
              : "http://image.8844it.com/ydb2/goodDefault.png";
            obj.goodsName = value.goodsName;
            obj.classify = value.categoryName;
            obj.items = value.items;
            obj.specificationItems = value.specificationItems;
            arr.push(obj);
          });
          this.dialogTableList = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      });
    },
    // 点击商品列表选择按钮
    choiceGoods(row) {
      this.selectDialogTableData = [];
      this.selectDialogGoods.id = row.id;
      this.selectDialogTableData.push(row)
    },
    // 翻页
    updatePage(data) {
      this.page = data.currentPage;
      this.getGoodsListData();
    },
    // 删除点击添加商品sku
    deleteGoodsItems(index) {
      this.selectDialogTableData.splice(index, 1);
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogTableVisible = false;
    },
    // 弹窗点击保存按钮
    saveGoodsSku() {
      if (this.selectDialogTableData.length > 0) {
        let data = {}
        data.boothId = Number(this.boothId)
        data.goodsId = this.selectDialogGoods.id
        if (this.selectDialogGoods.biddingPrice!='') {
          if (Number(this.selectDialogGoods.biddingPrice)>Number(this.standDetail.basePrice)) {
            data.price = Number(this.selectDialogGoods.biddingPrice)
          } else {
            this.$message({
              message: '竞价金额必须大于起拍价',
              center: true,
              type: 'error',
              duration: 1000
            });
            return
          }
        } else {
          this.$message({
            message: '请输入竞价金额',
            center: true,
            type: 'error',
            duration: 1000
          });
          return
        }
        supplier.getAddStandGoods(data).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '新增商品成功!'
            });
            this._getStandBiddingGoods(this.boothId);
          } else {
            this.$message.error(res.message);
          }
        })
        this.closeDialog();
      } else {
        this.$message.error("请添加商品");
      }
    },
    // 获取商品分类列表
    getGoodsClassify(boothId) {
      supplier.getChildrenCate(boothId).then((res) => {
        if (res.success) {
          this.classify = []
          this.classify.push(res.result);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    addGoods() {
      this.dialogTableVisible = true
      this.$nextTick(() => {
        this.$refs.cascader.inputValue = this.$route.query.categoryName
      })
    },
    modifyBidding(row) {
      this.boothGoodsId = row.boothGoodsId
      this.ruleForm.biddingPrice = row.currentPrice
      this.dialogVisible = true;
    },
    toBiddingActivities() {
      this.$router.push({
        path: "/supplier/spl-bidding/stand-index/bidding-stand",
        query: {
          categoryId: this.$route.query.categoryId   
        }
      });
    },
    //获取基础信息
    _getStandBaseInfo(boothId) {
      supplier.getStandBaseInfo(boothId).then(res => {
        if (res.success) {
          let obj = {}
          obj.serial = res.result.serial
          obj.basePrice = res.result.basePrice
          obj.biddingStatus = res.result.biddingStatus
          obj.expireTime = formaTimeToSecond(res.result.expireTime)
          this.standDetail = obj
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      });
    },
    //获取展位竞价商品
    _getStandBiddingGoods(boothId) {
      supplier.getStandBiddingGoods(boothId).then(res => {
        if (res.success) {
          this.standDetailsList = []
          let obj = {}
          if (res.result.boothGoodsCreatedAt != 0) {
            obj.boothGoodsCreatedAt = formaTimeToSecond(res.result.boothGoodsCreatedAt)
          }
          obj.goodsName = res.result.goodsName
          obj.currentPrice = res.result.currentPrice
          obj.boothGoodsId = res.result.boothGoodsId
          obj.isSelected = res.result.isSelected
          obj.isSelectedValue = this.isSelectedValue[res.result.isSelected]
          if (res.result.boothGoodsId != 0) {
            this.standDetailsList.push(obj)
          }
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }

      })
    },
    submit() {
      let data = {}
      data.boothGoodsId = this.boothGoodsId
      if (Number(this.ruleForm.price)&&(this.ruleForm.price!='')&&Number(this.ruleForm.price)>0) {
        if (Number(this.ruleForm.price)>Number(this.standDetail.basePrice)) {
          data.price = this.regPrice(this.ruleForm.price)
        } else {
          this.$message({
            message: '修改金额必须大于起拍价',
            center: true,
            type: 'error',
            duration: 1000
          });
          return
        }
      } else {
        this.$message({
          message: '请输入正确的数字格式',
          center: true,
          type: 'error',
          duration: 1000
        });
        return
      }
      supplier.getStandModifyMoney(data).then(res => {
        if (res.success) {
          this._getStandBiddingGoods(this.boothId);
          this.dialogVisible = false;
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      })
    },
    revoke(id) {
      this.$confirm('是否撤销该活动商品?', '撤销', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      }).then(() => {
        let data = {}
        data.boothGoodsId = id
        supplier.getRemoveStandGoods(data).then(res => {
          if (res.success) {
            this._getStandBiddingGoods(this.boothId);
            this.$message({
              type: 'success',
              message: '撤销成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      })
    },
    // 价钱输入
    regPrice(price) {
      let RetailPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      return RetailPrice;
    },
  },
  created() {
    this.boothId = this.$route.query.boothId
    this.getGoodsListData();
    this._getStandBaseInfo(this.boothId)
    this._getStandBiddingGoods(this.boothId)
    this.getGoodsClassify(this.boothId)
    this.getGoodsListData()
    
  },
  mounted() {
    const paddingWidth = 46;
    this.$refs.operations.style.width =
      this.$refs.baseInfo.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.baseInfo.clientWidth + paddingWidth + "px";
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
  },
};
</script>

<style lang="scss" scoped>
.splStand-detail {
  .add-promotion {
    margin-bottom: 16px;
  }
  .nothing {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
    .img {
      width: 184px;
      height: 243px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .btn-black {
    background: #EEEEEE;
    color: #999999;
  }
}
</style>
<style lang="scss">
#splStandDetail {
  .link-content-inner-container > .content {
    margin-top: 0px;
  }
  .modify-bidding {
    .el-dialog {
      margin-top: 32vh !important;
      .el-dialog__header {
        border-bottom: 1px solid #eee;
        .el-dialog__title {
          font-size: 16px;
          font-weight: bold;
          color: #666666;
          line-height: 24px;
        }
      }
      .el-dialog__footer {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 72px;
        border-top: 1px solid #eee;
      }
      .el-dialog__body {
        padding-bottom: 0;
        .el-form {
          padding: 20px 0px;
          .el-form-item__content {
            .el-input,
            .el-input__inner {
              height: 32px;
              background: rgba(245, 247, 250, 0.2);
            }
            .line {
              text-align: center;
            }
          }
          .el-form-item {
            height: 32px;
            margin-bottom: 16px;
          }
          .el-form-item:nth-last-child(1) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  
  /* 商品弹框列表 */
  .el-dialog {
    .flex {
      display: flex;
      height: 360px;
      border-bottom: 1px solid #f7f7f7;
      .flex-left {
        max-width: 584px;
        min-width: 584px;
        padding-right: 19px;
        box-sizing: border-box;
        border-right: 1px solid #e2e2e2;
        .dialog-search {
          margin-bottom: 16px;
          .w160 {
            width: 160px;
            margin-right: 16px;
          }
          .el-input {
            width: 160px;
            margin-right: 16px;
          }
          .el-button {
            width: 60px;
          }
        }
        .table_pagination {
          display: flex;
          justify-content: flex-end;
        }
      }
      .flex-right {
        max-width: 584px;
        min-width: 584px;
        padding-left: 20px;
        box-sizing: border-box;
        .specifications {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          .specifications-left {
            display: flex;
            align-items: center;
            .specifications-title {
              line-height: 32px;
              display: flex;
              align-items: center;
            }
            .specifications-list {
              display: flex;
              margin-left: 6px;
              .specifications-label {
                max-width: 68px;
                line-height: 32px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              .el-select {
                width: 80px;
              }
            }
          }
          .el-button {
            width: 50px;
            padding: 0;
          }
        }
      }
    }
    .dialog-footer {
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>